import { useState } from 'react';
import {
  Box,
  Button,
  TextField
} from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../helpers/theme';

import { createReport } from '../api';




export default function ReportButton({ token, id_sku }) {
  const [motive, setMotive] = useState("");
  const [disabled, setDisabled] = useState(false);


  const handleSubmit = async () => {
    let response = await createReport(id_sku, motive);

    if (response) {
      setDisabled(true);
    }
  };


  return (
    <Box sx={{ display: "flex", width: "100%", maxWidth: "620px", minWidth: 0, height: { xs: "auto", sm: "50px" }, marginY: "45px", flexDirection: { xs: "column", sm: "row" } }}>
      <Box
        sx={{
          "border": 1,
          "borderRadius": "200px",
          "borderColor": theme => theme.palette.border.main,
          "alignItems": "center",
          "justifyContent": "center",
          "width": { xs: "100%", sm: "460px" },
          "heigth": "50px",
          "paddingX": "16px"
        }}
      >
      <TextField 
        placeholder='Qual informação está errada?'
        aria-label="Descreva a informação incorreta"
        fullWidth
        id="fullWidth"
        onChange={ e => setMotive(e.target.value) }
        variant="standard"
        InputProps={{
          disableUnderline: true,
          style: { fontSize: 16 },
        }}
        sx={{
          "marginTop": "9px"
        }}
      />
      </Box>
      

      <ThemeProvider theme={theme}>
        <Button
          variant="contained"
          disableRipple
          disabled={disabled}
          onClick={handleSubmit}
          color="red"
          sx={{
            "fontSize": 16,
            "borderRadius": "200px",
            "width": "140px",
            "marginLeft": { xs: 0, sm: "32px" },
            "marginTop": { xs: "16px", sm: 0 },
            "textTransform": "capitalize",
          }}
        >
          Reportar
        </Button>
      </ThemeProvider>
    </Box>
  )
}